export const resizeImage = (width, height, setStateFrom, original, type) => {
  const { pathImage, pathImageOld } = original

  if (!pathImage) return

  if (pathImage.img) {
    let resultDivision = 0
    if (pathImage.width > pathImage.height) {
      resultDivision = pathImage.width / pathImage.height
    } else {
      resultDivision = pathImage.height / pathImage.width
    }

    if (typeof width === "undefined" || typeof height === "undefined") {
      setStateFrom("imageWidth", pathImage.width)
      return setStateFrom("imageHeight", pathImage.height)
    }

    if (type === "height") {
      const calcWidth = resultDivision * height

      if (calcWidth > 700) {
        setStateFrom("imageWidth", 700)
        setStateFrom("imageHeight", 700 / resultDivision)
      } else {
        setStateFrom("imageWidth", Math.trunc(calcWidth))
        setStateFrom("imageHeight", height)
      }
    }

    if (type === "width") {
      const calcHeight = width / resultDivision

      if (calcHeight > 700) {
        setStateFrom("imageWidth", 700)
        setStateFrom("imageHeight", 700 / resultDivision)
      } else {
        setStateFrom("imageWidth", width)
        setStateFrom("imageHeight", Math.trunc(calcHeight))
      }
    }
    return
  }

  let resultDivision = 0

  if (pathImageOld.width > pathImageOld.height) {
    resultDivision = pathImageOld.width / pathImageOld.height
  } else {
    resultDivision = pathImageOld.height / pathImageOld.width
  }

  if (typeof width === "undefined" || typeof height === "undefined") {
    setStateFrom("imageWidth", pathImageOld.width)
    return setStateFrom("imageHeight", pathImageOld.height)
  }

  if (type === "height") {
    const calcWidth = resultDivision * height

    if (calcWidth > 700) {
      setStateFrom("imageWidth", 700)
      setStateFrom("imageHeight", 700 / resultDivision)
    } else {
      setStateFrom("imageWidth", Math.trunc(calcWidth))
      setStateFrom("imageHeight", height)
    }
  }

  if (type === "width") {
    const calcHeight = width / resultDivision

    if (calcHeight > 700) {
      setStateFrom("imageWidth", 700)
      setStateFrom("imageHeight", 700 / resultDivision)
    } else {
      setStateFrom("imageWidth", width)
      setStateFrom("imageHeight", Math.trunc(calcHeight))
    }
  }
}
